import { Component, useState } from 'react'
import { Col, Row, Input } from 'reactstrap'
import AddPromotionModal from "./AddPromotionModal"
import withApolloClient from '../withApolloClient'
import AdvancedFilters from '../Filters/AdvancedFilters'
import AdvancedFiltersTrigger from '../Filters/AdvancedFiltersTrigger'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'
import { useAdvancedFilters } from '../Filters/filterUrl'
import { countVisibleFilters } from '../Filters/presetFilters'

// Advanced filters live in the URL (useAdvancedFilters); the editable is_active
// preset is owned by the container and passed down so the popover, the chips,
// and the list query all share one source of truth.
function PromoAdvancedFiltersControl({ presets, setPresets }) {
    const [isOpen, setIsOpen] = useState(false)
    const [advancedFilters, setAdvancedFilters] = useAdvancedFilters()
    return (
        <>
            <AdvancedFiltersTrigger compact count={countVisibleFilters(presets, advancedFilters)} onClick={() => setIsOpen(!isOpen)} />
            {isOpen && (
                <AdvancedFilters
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    entity="promotion_template"
                    context={null}
                    activeFilters={advancedFilters}
                    onApply={(newFilters) => setAdvancedFilters(newFilters)}
                    presets={presets}
                    onPresetsChange={setPresets}
                />
            )}
        </>
    )
}

class PromoListHeader extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }
    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }

    render() {
        return (
            <Row className="pb-2 align-items-center">
                {this.state.openModal === "addPromotionModal" && <AddPromotionModal isOpen={this.state.openModal === "addPromotionModal"} toggleModal={() => this.toggleModal("addPromotionModal")} refetch={() => this.props.refetchQuery()} />}
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs="auto" className="p-0">
                    <PromoAdvancedFiltersControl presets={this.props.presets} setPresets={this.props.setPresets} />
                </Col>
                <Col className="text-right">
                    <a id="viewFilters" className="driver-list-button" onClick={() => this.toggleModal("addPromotionModal")}>
                        Add New Promo | <i className="fa fa-plus" aria-hidden="true"></i>
                    </a>
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity="promotion_template"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                </Col>
            </Row>
        )
    }
}


export default withApolloClient(PromoListHeader)
